import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import SubcontractorEmployees from './SubcontractorEmployees';

const SubcontractorEmployeesPage = () => {
  const { subcontractorId } = useParams();
  const navigate = useNavigate();

  return (
    <div>
      <Button 
        icon={<ArrowLeftOutlined />} 
        style={{ marginBottom: 16 }} 
        onClick={() => navigate('/subcontractors')}
      >
        Back to Subcontractors
      </Button>
      <SubcontractorEmployees subcontractorId={subcontractorId} />
    </div>
  );
};

export default SubcontractorEmployeesPage; 